import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Checkbox, FormControlLabel, Typography } from "@mui/material";
import PublishIcon from "@mui/icons-material/Publish";
import Langs from "../../../app/lang/langs";
import ConfirmDialog from "../../../components/popups/ConfirmDialog";
import { showErrorToast, checkPermission } from "../../../app/utils/helpers";
import { submitShifts, getPlanning } from "../planningSlice";
import { setIsLoading } from "../../common/commonSlice";
import { config } from "../../../app/utils/config";

export function MobilePublishModal({ show, onHide }) {
  const dispatch = useDispatch();

  const selectedTeamsIds = useSelector((state) => state.teams.selectedTeamsIds);
  const selectedDate = useSelector((state) => state.planning.selectedDate);
  const collabs = useSelector((state) => state.collabs.list);

  const [notifyCollabs, setNotifyCollabs] = useState(true);

  function isManager(teamId) {
    return checkPermission(
      config.scopes.shifts,
      config.permissionTypes.edit,
      teamId
    );
  }

  function handlePublish() {
    onHide();
    dispatch(setIsLoading(true));

    dispatch(
      submitShifts({
        teamIds: selectedTeamsIds.filter((id) => isManager(id)),
        date: selectedDate,
        notify: notifyCollabs,
      })
    ).then((response) => {
      dispatch(setIsLoading(false));
      if (response["payload"]["responseData"]) {
        loadPlanning();
      }
      if (response["payload"]["responseError"]) {
        showErrorToast();
      }
    });
  }

  function loadPlanning() {
    if (selectedTeamsIds && selectedTeamsIds.length && collabs.length) {
      let selectedCollabsIds = collabs.reduce((array, current) => {
        array.push(current.id);
        return array;
      }, []);
      dispatch(getPlanning({ selectedTeamsIds, selectedCollabsIds }));
    }
  }

  return (
    <ConfirmDialog
      open={!!show}
      icon={PublishIcon}
      title={<Langs str="PUBLISH" />}
      message={<Langs str="PUBLISH_CONFIRMATION" />}
      confirmLabel={<Langs str="PUBLISH" />}
      onConfirm={handlePublish}
      onCancel={onHide}
    >
      <FormControlLabel
        sx={{ mt: 1.5 }}
        control={
          <Checkbox
            checked={notifyCollabs}
            onChange={(e) => setNotifyCollabs(e.target.checked)}
            sx={{ color: "#FF9015", "&.Mui-checked": { color: "#FF9015" } }}
          />
        }
        label={<Typography variant="body2"><Langs str="NOTIFY_COLLABS" /></Typography>}
      />
    </ConfirmDialog>
  );
}
